import { Group, GroupDisplayName, GroupNameDto } from '../../models';

export function getGroupName(group: Group | GroupNameDto, name: GroupDisplayName): string {
    let result: string;

    switch (name) {
        case GroupDisplayName.Name:
            result = group.name;
            break;
        case GroupDisplayName.UniqueName:
            result = group.uniqueName;
            break;
        case GroupDisplayName.AbsoluteName:
            result = group.absoluteName;
            break;
        case GroupDisplayName.None:
        default:
            break;
    }

    return result;
}